import { Env, throwIfFalsy } from '@utils';

throwIfFalsy(import.meta.env.VITE_API_URL, `'VITE_API_URL' variable must be set`);

export const ENV: Env = {
    API_URL: import.meta.env.VITE_API_URL
};
